/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'form-error',
  template: `<mat-card appearance="outlined">
    <mat-card-content
      ><div class="row">
        <div class="error"><ng-content></ng-content></div> </div
    ></mat-card-content>
  </mat-card>`,
  styles: [
    `
      .light-theme :host mat-card,
      .dark-theme :host mat-card {
        --mdc-outlined-card-container-color: var(--warn-color);
      }
      mat-card-content:first-child:last-child {
        padding: 22px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        color: var(--error-text-color);
        font-size: 16px;
      }
      .row {
        display: flex;
        align-items: center;
      }
      .error {
        flex: 1;
        color: var(--error-text-color);
        word-break: break-word;
      }
    `,
  ],
  standalone: true,
  imports: [MatCardModule],
})
export class FormErrorComponent {}
